import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/event/locations/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/event/locations`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/event/locations/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/event/locations`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/event/locations/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/event/locations/${url.id}`, data, config),
};

export default requests;
